export default "__VITE_ASSET__BVShs_Sj__"